// Copyright (c) 2016 Deere & Company

import {resetHistoryToDisplayCriteria, updateHistoryToDisplayCriteria} from './criteria';
import {
    selectAllDealersCriteria,
    selectAllDealersOnLoad,
    selectDealerCriteria
} from './select-dealer';
import {createSettlementNoRegistrationReport} from './create-report';
import {sharedActionCreators} from '../../shared/action-creators';

export default {
    createSettlementNoRegistrationReport,
    resetHistoryToDisplayCriteria,
    selectAllDealersCriteria,
    selectAllDealersOnLoad,
    selectDealerCriteria,
    updateHistoryToDisplayCriteria,
    ...sharedActionCreators
};



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/action-creators/index.js